var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analytic-tab-pane tab-pane"},[(_vm.showComponent)?_c('PaymentInterestReports'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }